import Header from "./Header";
import HeroImage from "./HeroImage";
import FooterSr from "./FooterSr";

function AboutUsFooter() {
  return (
    <div>
      <Header />
      <HeroImage />
      <div className="pt-16 px-4 md:px-8 lg:px-16 max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center md:text-left">
          आमच्या विषयी
        </h2>
        <p className="text-gray-700 text-base md:text-lg leading-relaxed">
          श्रद्धा आणि सेवेच्या माध्यमातून समाजात अध्यात्मिक जागृती निर्माण करणे
          <br />
          <br />
          शिव शंभर ट्रस्टची स्थापना भक्तांच्या श्रद्धेला एक शिस्तबद्ध व
          पारंपारिक व्यासपीठ देण्यासाठी करण्यात आली आहे. मंदिर व्यवस्थापन,
          धार्मिक विधी, सामाजिक सेवा आणि सांस्कृतिक उपक्रम यांचे नियोजनबद्ध
          संचालन करणे हा ट्रस्ट उद्देश आहे.
          <br />
          <br />
          महाराष्ट्रातील मुंबई शहरापासून साधारणतः ३० ते ३५ किलोमीटर अंतरावर
          बोरीवली–गोराई येथे शिव शंभो महादेव मंदिर हे जागृत देवस्थान म्हणून
          प्रसिद्ध आहे. परिसरातील स्थानिक सहकारी गृहनिर्माण संस्था (नऊदीप मित्र
          मंडळ) यांच्या सहकार्याने या मंदिराची निर्मिती झाली आहे. सन २०१६ मध्ये
          या मंदिराची नोंदणी मुंबई सार्वजनिक विश्वस्त व्यवस्था (धर्मादाय आयुक्त
          कार्यालय) अंतर्गत अधिकृतपणे करण्यात येऊन शिवशंभू मंदिर ट्रस्ट स्थापन
          करण्यात आला. शिव शंभो महादेव मंदिर हे शांत, पवित्र आणि भक्तीभावाने
          भरलेले स्थान आहे. मंदिराच्या गाभाऱ्यात शिवलिंग असून, श्री गणेश,
          अंबामाता, श्रीराम, लक्ष्मण व सीतेच्या मूर्ती देखील आहेत, ज्यामुळे
          मंदिराला भव्य व समृद्ध स्वरूप प्राप्त झाले आहे. तसेच मंदिराच्या आवारात
          काळा मारुती मंदिर, शीतला माता मंदिर व नवग्रह मंदिर सुद्धा आहेत. येथे
          नियमितपणे पूजा, अभिषेक, आरती तसेच विशेष धार्मिक कार्यक्रमांचे आयोजन
          केले जाते.
          <br />
          <br />
        </p>
      </div>
      <FooterSr />
    </div>
  );
}

export default AboutUsFooter;
